import { useEffect, useState } from "react";
import { QuestionPublic, api } from "../lib/api";
import QuestionCard from "../components/QuestionCard";

export default function DailyReview() {
  const [queue, setQueue] = useState<QuestionPublic[]>([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.dueCards(undefined, 20).then(setQueue);
  }, []);

  if (queue.length === 0) {
    return (
      <div className="card max-w-md mx-auto text-center">
        <h2 className="font-display text-2xl">Tout est à jour.</h2>
        <p className="text-sm text-scribe-600 mt-2">Reviens demain ou lance une pratique libre.</p>
      </div>
    );
  }
  if (idx >= queue.length) {
    return (
      <div className="card max-w-md mx-auto text-center">
        <h2 className="font-display text-2xl">Session de révision terminée.</h2>
      </div>
    );
  }

  return (
    <div>
      <p className="text-xs font-mono text-scribe-600 mb-4">
        Révision {idx + 1} / {queue.length}
      </p>
      <QuestionCard
        key={queue[idx].id}
        question={queue[idx]}
        mode="daily_review"
        onNext={() => setIdx(idx + 1)}
      />
    </div>
  );
}
